
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

  export const getAllProperties = createAsyncThunk(
    'property/getAllProperties',
    async () => {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/property/get-property`)
      return response.data;
    }
  ); 


  export const fetchPropertyListings = createAsyncThunk(
    'property/fetchPropertyListings',
    async (formData) => {
      const token = sessionStorage.getItem('token')
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/property/list/`,  formData,{
        headers: {
          Authorization: `token ${token}`,
        },
      });
      return response.data;
    }
  );